import { useCallback, useState } from 'react';

const usePromise = <Args extends any[], Return>(fn: (...args: Args) => Promise<Return>) => {
  const [loading, setLoading] = useState(false);
  const run = useCallback(
    async (...args: Args): Promise<Return> => {
      setLoading(true);
      try {
        // This can be used to simulate long loading state
        // await new Promise((resolve) => setTimeout(resolve, 2000))
        return await fn(...args);
      } finally {
        setLoading(false);
      }
    },
    [fn]
  );

  return { loading, run };
};

export default usePromise;
